import { useEffect } from 'react';
import EfImg from '@elem/ui/ef-img';
import EfLink from '@elem/ui/ef-link';
import EfSpec from '@elem/ui/ef-spec';
import { useMediaDevice } from '../../hooks';
import styles from './index.module.scss';
import { icon1, icon2, icon3, icon4, icon5, icon6 } from './Icons';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';

const icon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path
            d="M13.1667 8.23511H4.67433C4.38119 8.23511 4.14355 8.52468 4.14355 8.88189V14.7029C4.14355 15.0601 4.38119 15.3497 4.67433 15.3497H13.1667C13.4598 15.3497 13.6974 15.0601 13.6974 14.7029V8.88189C13.6974 8.52468 13.4598 8.23511 13.1667 8.23511Z"
            stroke="#4BC56E"
            strokeWidth="1.42292"
            strokeLinejoin="round"
        />
        <path
            d="M6.3374 8.22728V6.16066C6.3374 4.73396 7.49398 3.57739 8.92067 3.57739C10.3474 3.57739 11.5039 4.73396 11.5039 6.16066V8.22728"
            stroke="#4BC56E"
            strokeWidth="1.42292"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M8.9209 10.9795V12.5295" stroke="#4BC56E" strokeWidth="1.42292" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default function TheComp() {
    const { isPad, isDesktop, isPC, isH5 } = useMediaDevice();
    const { t } = useLang('Oasis.Safety');
    const { locale } = useRouter();
    const IS_NA_SITES = ['us', 'ca'].includes(locale ?? '');
    const list = [
        {
            title: 'TRUSTe',
            icon: icon1,
        },
        {
            title: 'NISTIR 8259',
            icon: icon2,
        },
        {
            title: 'NISTIR 8425',
            icon: icon2,
        },
        {
            title: 'PSTI',
            icon: icon3,
        },
        {
            title: 'ISO 9001',
            icon: icon4,
        },
        {
            title: 'FCC SDOC',
            icon: icon5,
        },
        {
            title: 'SRRC',
            icon: icon6,
        },
        {
            title: 'ISO 13849',
            icon: icon4,
        },
    ];

    // info 出现动画
    useEffect(() => {
        const info = document.querySelector('#Safety .info') as HTMLDivElement;
        const show = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        info.classList.add('enter');
                    }
                });
            },
            {
                threshold: 1,
            },
        );
        show.observe(info);
        return () => {
            show.disconnect();
        };
    }, []);

    // 动画
    useEffect(() => {
        if (isPad) return;
        const info = document.querySelector('#Safety .info') as HTMLDivElement;
        const mask = document.querySelector('#Safety .mask') as HTMLDivElement;
        const scene1 = AniContainer.create({
            triggerElement: '#Safety', // 触发元素
            triggerHook: 1, // 触发时机 1 进入 0 离开
            duration: '200%',
            offset: 0,
            asyncFromTo: [
                [mask, { opacity: 0 }, { opacity: 1 }, 0.4],
                [info, { opacity: 0 }, { opacity: 1 }, 0.3],
                [info, { opacity: 1 }, { opacity: 1 }, 1],
            ],
            asyncTimeLine: [0.1, 0.2, 1],
        });

        return () => {
            scene1.destroy();
        };
    }, [isPad, isDesktop, isPC, isH5]);

    return (
        <div className={`${styles.TheComp}`} id="Safety">
            <EfSpec />
            <div className="mask"></div>
            <div className="container">
                <div className="info">
                    <div className="label">
                        {icon}
                        <span>{t('label')}</span>
                    </div>
                    <div className="title">{t('title')}</div>
                    <div className="desc">
                        {t.rich('desc', {
                            h: (v) => <span className="highlight">{v}</span>,
                        })}
                        <EfLink
                            className="desc-link"
                            href="data-security-and-privacy"
                            dataLayer={
                                IS_NA_SITES
                                    ? null
                                    : {
                                          event: 'uaEvent',
                                          event_name: 'jump_button',
                                          position: 'Inpage',
                                          button_name: t('LearnMore'),
                                          url: 'data-security-and-privacy',
                                      }
                            }
                        >
                            {t('LearnMore')}
                        </EfLink>
                    </div>
                </div>

                <div className="content">
                    <div className="content-card">
                        {list.map((i, idx) => (
                            <div className="item" key={idx}>
                                <div>{i.icon}</div>
                                <span>{i.title}</span>
                            </div>
                        ))}
                    </div>
                    <EfImg
                        className="content-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1734660938662/Safety.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1734660938488/Safety-h5.jpg"
                    />
                </div>
            </div>
        </div>
    );
}
